import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cdef7e20")

_pushScopeId("data-v-cdef7e20")
const _hoisted_1 = { class: "main-panel flex-grow flex flex-col" }
const _hoisted_2 = { class: "flex-grow flex flex-col px-4 pt-6 overflow-y-scroll" }
const _hoisted_3 = { class: "flex flex-col flex-shrink-0 mb-8" }
const _hoisted_4 = { class: "mb-1 flex justify-center" }
const _hoisted_5 = { class: "flex items-center border border-primary-500 rounded-md text-sm text-primary-600" }
const _hoisted_6 = { class: "my-2 flex justify-center" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center text-sm"
}
const _hoisted_8 = {
  key: 0,
  class: "w-full"
}
const _hoisted_9 = {
  key: 1,
  class: "w-full sm:px-8"
}
const _hoisted_10 = {
  key: 1,
  class: "w-full h-60 flex items-center justify-center bg-gray-100 rounded-md"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "text-xs text-gray-700 px-4" }, " ※ 対象期間の学習履歴が存在しないため、グラフは表示できません ", -1)
const _hoisted_12 = { class: "w-full my-6 flex flex-col items-center" }
const _hoisted_13 = { class: "w-full py-2 flex items-center" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "mr-1 text-xs text-gray-700" }, "開始", -1)
const _hoisted_15 = { class: "w-full py-2 flex items-center" }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "mr-1 text-xs text-gray-700" }, "終了", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("h3", { class: "font-medium text-lg" }, "学習記録", -1)
const _hoisted_18 = { class: "flex flex-col flex-shrink-0 mt-4" }
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "flex flex-col flex-shrink-0 mb-8" }
const _hoisted_21 = /*#__PURE__*/_createVNode("h3", { class: "mb-4 font-medium text-lg" }, " みんがく学習室ポイント・連続記録 ", -1)
const _hoisted_22 = { class: "mb-4 flex" }
const _hoisted_23 = { class: "flex flex-col mb-8" }
const _hoisted_24 = { class: "flex items-center justify-between" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h3", { class: "font-medium text-lg" }, "学習履歴", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, "学習データを追加", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "text-gray-700 text-xs" }, [
  /*#__PURE__*/_createTextVNode(" ※通信が不安定な場合、まれにマイナス表示や「NaN」の表示となる場合があります。その場合は"),
  /*#__PURE__*/_createVNode("a", {
    class: "text-blue-500",
    href: "https://mingaku.net/guide/student-detail",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "学習データの編集・削除"),
  /*#__PURE__*/_createTextVNode("をお願いします。 ")
], -1)
const _hoisted_28 = { class: "flex flex-col p-3 rounded-md border-2 border-gray-200 transition-colors duration-300 hover:bg-gray-100" }
const _hoisted_29 = { class: "text-xs font-medium text-gray-500" }
const _hoisted_30 = { class: "font-medium" }
const _hoisted_31 = {
  key: 0,
  class: "flex flex-wrap"
}
const _hoisted_32 = {
  key: 0,
  class: "py-1 mr-3 mt-2 text-gray-500 text-sm"
}
const _hoisted_33 = {
  key: 1,
  class: "flex items-center mt-2 text-yellow-300"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "text-sm font-medium text-gray-500" }, " 振り返りが終わっていません ", -1)
const _hoisted_35 = {
  key: 0,
  class: "flex justify-center py-4"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("span", null, "さらに読み込む", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "h-20 lg:h-0" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MSPanelHeader = _resolveComponent("MSPanelHeader")
  const _component_ms_bar_chart = _resolveComponent("ms-bar-chart")
  const _component_ms_doughnut_chart = _resolveComponent("ms-doughnut-chart")
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_learning_summary_card = _resolveComponent("m-learning-summary-card")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_router_link = _resolveComponent("router-link")
  const _component_ms_add_learning_modal = _resolveComponent("ms-add-learning-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_MSPanelHeader, {
      "select-page": "history",
      onOpen: _ctx.open
    }, null, 8, ["onOpen"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("section", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", {
                class: ["py-1 px-2 border-r border-primary-500 cursor-pointer transition-colors duration-300", {
                'bg-primary-500': !_ctx.isBarChart,
                'text-white': !_ctx.isBarChart,
                'font-medium': !_ctx.isBarChart
              }],
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectIsBarChart(false)))
              }, " 円グラフ ", 2),
              _createVNode("div", {
                class: ["py-1 px-2 cursor-pointer transition-colors duration-300", {
                'bg-primary-500': _ctx.isBarChart,
                'text-white': _ctx.isBarChart,
                'font-medium': _ctx.isBarChart
              }],
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectIsBarChart(true)))
              }, " 棒グラフ ", 2)
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            (_ctx.labelChoices.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.labelChoices, (labelChoice) => {
                    return (_openBlock(), _createBlock("div", {
                      key: labelChoice.id,
                      class: "ml-3"
                    }, [
                      _createVNode("input", {
                        id: `label-choice-${labelChoice.id}`,
                        type: "radio",
                        name: "label-choice",
                        disabled: _ctx.waitingForNextAnimation,
                        checked: labelChoice.selected,
                        onChange: ($event: any) => (_ctx.selectLabelChoice(labelChoice))
                      }, null, 40, ["id", "disabled", "checked", "onChange"]),
                      _createVNode("label", {
                        for: `label-choice-${labelChoice.id}`,
                        class: "pl-1"
                      }, _toDisplayString(labelChoice.name), 9, ["for"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.chartDatasets.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                (_ctx.isBarChart)
                  ? (_openBlock(), _createBlock(_component_ms_bar_chart, {
                      key: 0,
                      labels: _ctx.chartLabels,
                      datasets: _ctx.chartDatasets
                    }, null, 8, ["labels", "datasets"]))
                  : (_openBlock(), _createBlock("div", _hoisted_9, [
                      _createVNode(_component_ms_doughnut_chart, {
                        labels: _ctx.doughnutLabels,
                        datasets: _ctx.doughnutDatasets
                      }, null, 8, ["labels", "datasets"])
                    ]))
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_10, [
                _hoisted_11
              ])),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_m_text_field, {
                name: "chartStart",
                type: "date",
                placeholder: "2021/04/01",
                value: _ctx.chartStart,
                entered: "",
                class: "flex-1",
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.chartStart = $event))
              }, null, 8, ["value"])
            ]),
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_m_text_field, {
                name: "chartStart",
                type: "date",
                placeholder: "2021/04/01",
                value: _ctx.chartEnd,
                entered: "",
                class: "flex-1",
                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.chartEnd = $event))
              }, null, 8, ["value"])
            ])
          ]),
          _hoisted_17,
          _createVNode(_component_m_learning_summary_card, {
            title: _ctx.totalTimeLabel,
            values: _ctx.totalTimeOfChart,
            class: "w-full mt-4"
          }, null, 8, ["title", "values"]),
          _createVNode("section", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode(_component_m_learning_summary_card, {
                title: "直近 7 日の学習時間",
                values: _ctx.sevenDaysTime,
                class: "mr-2 flex-1"
              }, null, 8, ["values"]),
              _createVNode(_component_m_learning_summary_card, {
                title: "直近 7 日の学習日数",
                values: _ctx.sevenDaysDayCount,
                class: "ml-2 flex-1"
              }, null, 8, ["values"])
            ])
          ])
        ]),
        _createVNode("section", _hoisted_20, [
          _hoisted_21,
          _createVNode(_component_m_learning_summary_card, {
            title: "累計獲得みんがくポイント",
            values: _ctx.point,
            class: "mb-4"
          }, null, 8, ["values"]),
          _createVNode("div", _hoisted_22, [
            _createVNode(_component_m_learning_summary_card, {
              title: "現在の連続学習日数",
              values: _ctx.currentRunningDayCount,
              class: "mr-2 flex-1"
            }, null, 8, ["values"]),
            _createVNode(_component_m_learning_summary_card, {
              title: "最長連続学習日数",
              values: _ctx.maxRunningDayCount,
              class: "ml-2 flex-1"
            }, null, 8, ["values"])
          ])
        ]),
        _createVNode("section", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_m_button, {
              color: "secondary-500",
              "hover-color": "secondary-600",
              text: "",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isDisplayAddLearningModal = true))
            }, {
              default: _withId(() => [
                _createVNode(_component_m_icon, { type: "plus" }),
                _hoisted_26
              ]),
              _: 1
            })
          ]),
          _hoisted_27,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.learningsForCard, (learning) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: learning.ref.id,
              to: _ctx.pathOf(learning),
              class: "mt-3"
            }, {
              default: _withId(() => [
                _createVNode("article", _hoisted_28, [
                  _createVNode("span", _hoisted_29, _toDisplayString(_ctx.leaningTypeOf(learning)), 1),
                  _createVNode("p", _hoisted_30, _toDisplayString(_ctx.timeTextOf(learning)), 1),
                  (_ctx.hasReflectionOf(learning))
                    ? (_openBlock(), _createBlock("div", _hoisted_31, [
                        (!!learning.data.reflection?.images?.length)
                          ? (_openBlock(), _createBlock("div", _hoisted_32, " 画像あり "))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subjectsOf(learning), (subject) => {
                          return (_openBlock(), _createBlock("span", {
                            key: subject,
                            class: "px-3 py-1 mr-3 mt-2 border border-secondary-500 rounded-full text-secondary-500 text-sm"
                          }, _toDisplayString(subject), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_33, [
                        _createVNode(_component_m_icon, {
                          type: "warning",
                          size: "6",
                          class: "mr-2"
                        }),
                        _hoisted_34
                      ]))
                ])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128)),
          (!_ctx.allLearningsFetched)
            ? (_openBlock(), _createBlock("div", _hoisted_35, [
                _createVNode("div", {
                  class: "px-4 py-2 rounded-md text-gray-700 text-sm underline transition-colors duration-300 cursor-pointer hover:bg-gray-100",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getMoreLearning && _ctx.getMoreLearning(...args)))
                }, [
                  _hoisted_36
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_37
        ])
      ])
    ]),
    (_ctx.isDisplayAddLearningModal)
      ? (_openBlock(), _createBlock(_component_ms_add_learning_modal, {
          key: 0,
          student: _ctx.student,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isDisplayAddLearningModal = false))
        }, null, 8, ["student"]))
      : _createCommentVNode("", true)
  ], 64))
})